import React from "react";
import heroImage from "../assets/Images/hero-8.jpg";
import { Box, Container, Typography } from "@mui/material";

export default function ChecksSection() {
  return (
    <Box
      sx={{
        borderTop: "4px solid #c6db8c",
        position: "relative",
        borderBottom: "4px solid #c6db8c",
        height: { xs: "auto", md: "80vh" },
        backgroundImage: `url(${heroImage})`, // اپنی image کا path دیں
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: { xs: "60px 20px", md: "0" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          opacity: 0.3,
          zIndex: 0,
        }}
      />
      <Container maxWidth="lg" sx={{ color: "white", zIndex: 1 }}>
        {/* Main Heading */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            mb: 3,
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Background Checks
        </Typography>

        {/* Background Checks Details */}
        <Typography
          variant="body1"
          sx={{ mb: 2, maxWidth: "900px", mx: "auto", textAlign: "justify" }}
        >
          <strong>Identity Check:</strong> This check will ensure that the
          employee is who he says he is by checking identity document databases.
          Recruitment agents/HR teams should ensure that all the names are
          provided correctly. Enhanced checks include online profiles.
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 2, maxWidth: "900px", mx: "auto", textAlign: "justify" }}
        >
          <strong>1. Address Check:</strong> This will match the identity of
          your employee to their current/previous addresses.
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 2, maxWidth: "900px", mx: "auto", textAlign: "justify" }}
        >
          <strong>2. Previous Employer Check:</strong> This will involve
          cross-checking employment records or information provided on your new
          recruit’s CV. Further recommendations can be requested.
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 2, maxWidth: "900px", mx: "auto", textAlign: "justify" }}
        >
          <strong>3. Education Check:</strong> This involves checking
          educational institutions stated on application forms or CVs.
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 4, maxWidth: "900px", mx: "auto", textAlign: "justify" }}
        >
          <strong>4. References Check:</strong> This involves checking that all
          referees provided are credible and in a position to provide an
          employee referral. References will also be contacted for information
          on the employee and previous performance.
        </Typography>

        {/* Criminality Checks Heading */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            mb: 3,
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Criminality Checks
        </Typography>

        {/* Criminality Checks Details */}
        <Typography
          variant="body1"
          sx={{ mb: 2, maxWidth: "900px", mx: "auto", textAlign: "justify" }}
        >
          <strong>1. Police Clearance:</strong> This will investigate any
          cautions, reprimands or time spent and unspent in custody. In an
          enhanced check, white collar crimes, fraud and online activity will
          also be investigated.
        </Typography>
        <Typography
          variant="body1"
          sx={{ maxWidth: "900px", mx: "auto", textAlign: "justify" }}
        >
          <strong>2. International Security Clearance:</strong> This advanced
          check exposes any international criminal activity in any country that
          the individual has resided in, travelled to or has online dealings
          with. This is an enhanced check service and will take a minimum of
          three to six months.
        </Typography>
      </Container>
    </Box>
  );
}
